<template>
  <v-layout column fill-height class="wrapper pa-0">
    <drip ref="drip" />
    <v-flex>
      <v-layout column fill-height align-center justify-center class="pa-4">
        <logo class="flex-none mb-9"/>
        <div class="headline text-center grey--text text--darken-1 notice" v-html="$t('unavailable_app.notice')"></div>
      </v-layout>
    </v-flex>
    <img src="@/assets/Background_characters.jpeg" alt="" class="flex-none">
  </v-layout>
</template>
<script>
export default {
  components: {
    Logo: () => import('@/components/app-components/Logo.vue'),
    Drip: () => import('@/components/app-components/Drip.vue')
  }
}
</script>

<style scoped>
.drip-image {
  max-width: 100%;
  max-height: 100px;
}
.notice {
  max-width: 820px;
}
</style>
